import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { fromJS, is } from 'immutable';
import tr from '../localization/translate';

function trTitle(props) {
  const { title, root, section, params } = props;
  const trId = root ? `${root}.${title}` : title;
  const sectionId = (root && section) ? `${root}.${section}` : '';
  const sectionTr = sectionId ? tr(`page_title.${sectionId}`, params) : '';

  return tr(`page_title.${trId}`, { section: sectionTr, ...params });
}

class TrTitle extends PureComponent {
  constructor(props) {
    super(props);

    this.paramsAsImmutable = fromJS(props.params);
  }

  componentDidMount() {
    if (this.props.params !== TrTitle.defaultProps.params) {
      global.analytics.page(this.props.category, this.props.name, { extra: this.props.params });
    } else {
      global.analytics.page(this.props.category, this.props.name);
    }
  }

  componentDidUpdate(prevProps) {
    const newParamsAsImmutable = fromJS(this.props.params);

    if (prevProps.name !== this.props.name || !is(newParamsAsImmutable, this.paramsAsImmutable)) {
      global.analytics.page(this.props.category, this.props.name, { extra: this.props.params });
    }

    this.paramsAsImmutable = newParamsAsImmutable;
  }

  render() {
    return (
      <Helmet>
        <title>{ trTitle(this.props) }</title>
      </Helmet>
    );
  }
}

/* eslint react/no-unused-prop-types: 0 */
TrTitle.propTypes = {
  category: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  root: PropTypes.string,
  section: PropTypes.string,
  params: PropTypes.object /* eslint react/forbid-prop-types: 0 */
};

TrTitle.defaultProps = {
  root: '',
  section: '',
  params: {}
};

export default TrTitle;

export const PageCategories = {
  ADMIN: 'Admin',
  AGENT: 'Agent',
  EMAIL: 'Email link',
  LOGIN: 'Login or register',
  PROFILE: 'Profile',
  PROPERTY: 'Property',
  MESSAGING: 'Messaging',
  ROOT: 'Igglo',
  CREDIT_CHECK: 'Credit check',
  INSURANCE: 'Rental insurance',
  DEPOSIT: 'Deposit',
  PAYMENT: 'Payment'
};
